module.exports = __webpack_public_path__ + "static/media/played-missed.4b6d0b7d.svg";